import { useStore } from "@src/utils/hooks/useStore";
import type { ScreenType } from "@src/utils/mobx/states/screen-type-state";
import { useSyncExternalStore } from "react";

export const useScreenType = (): ScreenType => {
  const { UIStore } = useStore();

  return useSyncExternalStore(
    UIStore.screenType.subscribe,
    UIStore.screenType.getSnapshot,
  );
};
